import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromBookmarksStore from '@purplefront/bookmarks/data-access';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Bookmark } from '@purplefront/bookmarks/data-access';
import { WINDOW } from '@purplefront/shared';

@Component({
  selector: 'app-bookmarks-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bookmarks-grid.component.html',
  styleUrls: ['./bookmarks-grid.component.scss']
})
export class BookmarksGridComponent implements OnInit {
  @Input() bookmarks: fromBookmarksStore.Bookmark[];
  @Input() isLoading: boolean;
  @Output() goToSearch = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();
  private _modalRef: NgbModalRef;

  public term: string;

  constructor(
    private _bookmarkStore: Store<fromBookmarksStore.BookmarksState>,
    private _bookmarksApiServices: fromBookmarksStore.BookmarksApi,
    private _modalService: NgbModal,
    @Inject(WINDOW) private window: Window
  ) {}

  ngOnInit() {}

  /**
   * Remove bookmark
   */
  open(bookmarkModal) {
    this._modalRef = this._modalService.open(bookmarkModal, {
      ariaLabelledBy: 'bookmarks-grid-modal',
      centered: true
    });
  }

  removeBookmark($event, id): void {
    $event.preventDefault();
    $event.stopPropagation();

    this._bookmarksApiServices.removeBookmark(id).subscribe(
      () => {
        this._bookmarkStore.dispatch(
          fromBookmarksStore.removeBookmark({
            payload: id
          })
        );
      },
      (error) =>
        this._bookmarkStore.dispatch(
          fromBookmarksStore.removeBookmarkFail({
            payload: { error: error }
          })
        )
    );
  }

  /**
   * On search click
   */

  searchTerm(bookmark) {
    this.goToSearch.emit(bookmark);
  }

  /**
   * openBookmark
   */

  openBookmark(bookmark, $event) {
    if (bookmark.context.contextType === 'reader' || bookmark.context.contextType === 'radar') {
      $event.preventDefault();
      this.window.open(bookmark.context.source, '_blank');
    } else {
      $event.preventDefault();
      this.openModal.emit(bookmark);
    }
  }

  removeAllBookmark() {
    this._modalRef.close();
    this._bookmarkStore.dispatch(fromBookmarksStore.removeAllBookmark());
  }

  drop(event: CdkDragDrop<Bookmark[]>) {
    moveItemInArray(this.bookmarks, event.previousIndex, event.currentIndex);
  }
}
